import AppLoader from 'Components/AppLoader';
import { useUserEffect } from 'Components/Authorize/guardHelpers';
import { memo, useEffect } from 'preact/compat';

import { useSelector } from '@/redux/helper';

import { getRedirectURLLocalStorage, loadPage } from '../../../helpers';

const GuestOnlyGuard = ({ redirectRoute, fallback, children, overrideHistory }) => {
  useUserEffect();

  const logged = useSelector((state) => state.user.logged);
  const sessionChecked = useSelector((state) => state.user.sessionChecked);
  const hasFallback = !!fallback;

  useEffect(() => {
    if (!logged || !sessionChecked || hasFallback) {
      return undefined;
    }
    const newPath = getRedirectURLLocalStorage();
    if (!overrideHistory && newPath) {
      const newPathURL = new URL(newPath, window.location.origin);
      loadPage(`${newPathURL.pathname}${newPathURL.search}`);
      return undefined;
    }
    const redirectRouteURL = new URL(redirectRoute || newPath || '/home', window.location.origin);
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.delete('ml'); // remove magic link token
    if (['/map', '/home'].includes(redirectRouteURL.pathname) && searchParams.size > 0) {
      searchParams.forEach((value, key) => {
        redirectRouteURL.searchParams.set(key, value);
      });
    }
    // here we use loadPage(window.open or window.location) instead of route
    // is due that the main routes don't exist in the public routing pages
    loadPage(`${redirectRouteURL.pathname}${redirectRouteURL.search}`);
    return undefined;
  }, [logged, sessionChecked, hasFallback, redirectRoute, overrideHistory]);

  if (sessionChecked) {
    return logged ? fallback || <AppLoader /> : children;
  }

  return <AppLoader />;
};

export default memo(GuestOnlyGuard);
